const seriesElement = () => {

    const parent      = '.js-series-element';
    const link        = $('.js-series-element-link');
    const activeClass = 'series-element--active';

    link.on('click', function(e){
        const element = $(this).parents(parent);

        $(parent).removeClass(activeClass);

        if ( !element.hasClass(activeClass) ) {
            element.addClass(activeClass);
        }
        else {
            element.removeClass(activeClass);
        }
    });

    $(document).on("mouseup touchend", function(e){
        if (!$(parent).is(e.target) && $(parent).has(e.target).length === 0) {
            $(parent).removeClass(activeClass);
        }
    });
}